import { useEffect, useState } from "react";

export default function AboutHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative w-full h-[70vh] min-h-[520px] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artisan%20hands%20crafting%20Tibetan%20dzi%20bead%20bracelet%20natural%20crystal%20jewelry%20making%20process%20close%20up%20warm%20golden%20workshop%20light%20bokeh%20background%20luxury%20oriental%20craft%20photography%20serene%20peaceful%20atmosphere%20high%20detail&width=1920&height=1080&seq=about_hero001&orientation=landscape"
          alt="關於瓏靖手作能量"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1e1a16]/85 via-[#1e1a16]/40 to-[#1e1a16]/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-16 pb-20 pt-32">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#c9a96e]"></span>
            <span
              className="text-[#c9a96e] text-[1rem] tracking-[0.35em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              OUR STORY
            </span>
          </div>
          <h1
            className="text-white font-bold leading-[1.3] mb-5"
            style={{
              fontSize: "clamp(2rem, 4.5vw, 2.75rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            關於瓏靖手作能量
          </h1>
          <p
            className="text-white/70 max-w-xl leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            一份對東方文化的熱愛，一雙傳遞祝福的手，成就了每一件守護你的能量飾品。
          </p>
        </div>
      </div>
    </section>
  );
}
